import * as React from 'react'
import { dispatchToProps, IVoiceRecordingSelectProps } from './VoiceRecordingSelect.container'
import SelectPretty from 'components/Input/SelectPretty'
import { IVoice } from '../types'
import { flatMap } from 'lodash'
import config from 'src/config'

export interface IVoiceRecordingSelectComponentProps extends IVoiceRecordingSelectProps {
  getVoices: typeof dispatchToProps['getVoices']
  showVoiceCreateModal: typeof dispatchToProps['showVoiceCreateModal']
  showFileUploadModal: typeof dispatchToProps['showFileUploadModal']
  results: IVoice[]
}

export class VoiceRecordingSelectComponent extends React.Component<
  IVoiceRecordingSelectComponentProps
> {
  componentWillMount() {
    const { getVoices } = this.props
    getVoices({ page: 1, cacheKey: '1' })
  }
  render() {
    const { results, input, meta, showVoiceCreateModal, showFileUploadModal } = this.props
    const options = [
      ...flatMap(results, voiceProject =>
        flatMap(voiceProject.reads, (read, readIdx) =>
          flatMap(read.urls, (scriptRead, scriptName) => ({
            name: `${voiceProject.title} - Read ${readIdx + 1} - ${scriptName}`,
            value: scriptRead.default,
          }))
        )
      ),
      {
        name: 'Commission a voice actor recording...',
        value: 'record',
        onClick: () => showVoiceCreateModal({}),
      },
      {
        name: `None (use the 'Message' above)...`,
        value: 'none',
        onClick: () => input.onChange({}),
      },
      {
        name: 'Upload a file...',
        value: 'upload',
        onClick: () =>
          (showFileUploadModal({ uploadType: 'audio' }) as any) // is this ok?
            .then(({ value }) => {
              input.onChange(value)
            }),
      },
    ]

    return (
      <div>
        <SelectPretty
          label="Voice actor recording"
          input={{
            ...input,
            onChange: value =>
              input.onChange({
                id: value,
              }),
            value:
              input.value && input.value.id && input.value.id.startsWith('http')
                ? input.value.id
                : input.value.name,
          }}
          meta={meta}
          options={options}
        />
        {input.value && input.value.id && (
          <audio controls style={{ width: '100%', marginBottom: '20px' }}>
            <source
              src={
                input.value.id.startsWith('http')
                  ? input.value.id
                  : `${config.api.portal}/api/v1/twilio/media/${input.value.id}`
              }
            />
          </audio>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Voices/VoiceRecordingSelect/VoiceRecordingSelect.tsx